// This version is for use without es6 modules

import slider from './modules/slider'
window.slider = slider
